import JSZip from 'jszip';
import {
  normalizeSampleLocalSnapshot,
  type SampleLocalSnapshot,
} from './sampleLocalDb';
import { sampleLocalStore } from './sampleLocalStore';

const DATA_JSON = 'sample-manager/sample-data.json';
const README_PATH = 'README.txt';

function buildReadme(): string {
  return [
    'Kensuke Sample Manager — local Zip (source of truth)',
    '',
    'This archive holds samples, storage rooms, and usage records.',
    'Open it in kensuke-system Sample Manager (guest / Zip mode).',
    'Do not edit sample-data.json by hand unless you know the schema.',
    '',
  ].join('\n');
}

export async function buildSampleZipArrayBuffer(snapshot: SampleLocalSnapshot): Promise<ArrayBuffer> {
  const zip = new JSZip();
  zip.file(README_PATH, buildReadme());
  zip.file(DATA_JSON, JSON.stringify(snapshot));
  return zip.generateAsync({ type: 'arraybuffer', compression: 'DEFLATE' });
}

export async function buildSampleZipBlob(snapshot: SampleLocalSnapshot): Promise<Blob> {
  const buf = await buildSampleZipArrayBuffer(snapshot);
  return new Blob([buf], { type: 'application/zip' });
}

export async function parseSampleZipBuffer(buffer: ArrayBuffer): Promise<SampleLocalSnapshot> {
  const zip = await JSZip.loadAsync(buffer);
  const entry = zip.file(DATA_JSON);
  if (!entry) {
    throw new Error('sample.zip_missing_data');
  }
  const text = await entry.async('string');
  const raw = JSON.parse(text) as unknown;
  return normalizeSampleLocalSnapshot(raw);
}

export async function importSampleZip(file: File | Blob): Promise<SampleLocalSnapshot> {
  const buffer = await file.arrayBuffer();
  const snap = await parseSampleZipBuffer(buffer);
  await sampleLocalStore.replaceSnapshot(snap);
  return snap;
}

export async function exportSampleZip(): Promise<Blob> {
  const snap = sampleLocalStore.getSnapshot();
  return buildSampleZipBlob(snap);
}
